import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { SharedServices } from '../../services/shared.services'
import { getImageRedirectUrl, undefinedIsTrue } from '../../../helper/common'
import { MatrixServices } from '../../services/image/matrix.services'
import { sortBy } from 'lodash'
import Constants from '../../commons/Constants'
import { ImageComponent as BaseImageComponent } from '../../commons/image/image.component'

@Component({
    selector: 'ons-page[tabImage]',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.css'],
})
export class ImageComponent implements OnInit {
    arrayTitleImage = Constants.TREATMENT_MOBILE_TABS
    currentImg = 1
    preImg = 0
    arraySubTitle = this.arrayTitleImage[1].subTitle
    paddingScroll = 300
    listImg = this.arrayTitleImage[1].subTitle[0].data
    clientVisitInfo
    dateDisplay = ''
    imgActive = ''
    matrixImage
    currentIdTitle = 1
    currentIdChildren = 0
    showImgMatrix = false
    matrixImageCenter
    imageSize = 'medium'
    imageSizeSmall = 'small'
    listMatrix = []
    jsonInitClientVisit: any = {}
    private isVisible: boolean = false
    @ViewChild('showImage') showImage: BaseImageComponent
    @ViewChild('parent_div') parent_div: ElementRef
    private clientInfo: any
    useTreatmentMenu = false

    constructor(private _sharedService: SharedServices, public matrixServices: MatrixServices) {
        console.log('Image component -----------')
    }

    ngOnInit() {
        this._sharedService.changeEmittedSource$.subscribe(
            success => {
                this.clientInfo = success[0]
                this.useTreatmentMenu = undefinedIsTrue(this.clientInfo.useTreatmentMenu)
                this.clientVisitInfo = success[2]
                this.caculatorDataImg()
                this.activeButton(1, -1)
                this.activeButton(0, 1)
                if (this.listImg.length >= 1 && this.listImg[0].dateString) {
                    this.dateDisplay = this.listImg[0].dateString
                    this.imgActive = this.listImg[0].id
                }
            },
        )
        const parent_div = this.parent_div.nativeElement
        this.paddingScroll = parent_div.offsetWidth / 2
        if (parent_div.offsetWidth > 480) {
            this.imageSize = 'large'
        }
    }

    activeButton(index, parentId = -1) {
        this.currentImg = 1
        this.preImg = 0
        if (parentId === -1 && index != this.currentIdTitle) {
            this.matrixServices.resetMatrix()
        } else if (parentId != -1 && (index != this.currentIdChildren || parentId != this.currentIdTitle)) {
            this.matrixServices.resetMatrix()
        }
        if (parentId === -1) {
            this.arraySubTitle = this.arrayTitleImage[index].subTitle
            this.currentIdTitle = index
            for (let i = 0; i < this.arrayTitleImage.length; i++) {
                if (i === index) {
                    this.arrayTitleImage[i].active = true
                    for (let j = 0; j < this.arraySubTitle.length; j++) {
                        if (this.arraySubTitle[j].active) {
                            this.listImg = this.arrayTitleImage[this.arraySubTitle[j].parentId].subTitle[j].data
                            this.currentIdChildren = j
                            break
                        }
                    }
                } else {
                    this.arrayTitleImage[i].active = false
                }
            }
        } else {
            this.currentIdTitle = parentId
            this.currentIdChildren = index
            for (let i = 0; i < this.arraySubTitle.length; i++) {
                if (i === index) {
                    this.arraySubTitle[i].active = true
                    this.listImg = this.arrayTitleImage[this.arraySubTitle[i].parentId].subTitle[i].data
                } else {
                    this.arraySubTitle[i].active = false
                }
            }
        }
        if (this.listImg.length > 0) {
            this.dateDisplay = this.listImg[0].dateString
            this.imgActive = this.listImg[0].id
        } else {
            this.dateDisplay = ''
            this.imgActive = ''
        }
        this.getImageMatrix()
        this.fillShowImage()
    }

    fillShowImage() {
        setTimeout(() => {
            if (this.showImage) {
                this.showImage.imageObservable.next({
                    imageUrl: getImageRedirectUrl(this.imgActive + '?type=' + this.imageSize),
                    matrix: this.listImg[this.currentImg - 1] ? this.listImg[this.currentImg - 1].matrix : [1, 0, 0, 1],
                    style: this.listImg[this.currentImg - 1]['style'] ? this.listImg[this.currentImg - 1]['style'] : {},
                })
            }
        })
    }

    actionVideo() {
        const video: any = document.getElementById('video')
        if (video != undefined && video.paused) {
            video.play()
        } else if (video != undefined && video.played) {
            video.pause()
        }
    }

    getUrlVideo(idImage) {
        return getImageRedirectUrl(idImage)
    }
    getUrlVideoThumb(index) {
        return  getImageRedirectUrl(this.listImg[index].id)
    }

    getUrlImage(idImage) {
        return getImageRedirectUrl(idImage + '?type=' + this.imageSizeSmall)
    }

    isHasImage() {
        if (this.arraySubTitle && this.arraySubTitle[0] && this.arraySubTitle[0].key.indexOf('movie') !== -1) {
            return false
        }
        return true
    }

    onScroll($event) {
        let scrollPosition = 0
        if ($event.srcElement) {
            //Chorme, Safari
            scrollPosition = $event.srcElement.scrollLeft
        } else {
            //Firefox
            scrollPosition = $event.target.scrollLeft
        }
        if (scrollPosition > (64 * this.currentImg + 32 * this.preImg) && this.currentImg < this.listImg.length) {
            this.currentImg++
            this.preImg++
            this.matrixImageCenter = {
                'text-align': 'center',
            }
        } else if (scrollPosition < (64 * this.preImg + 32 * (this.preImg - 1)) && this.currentImg > 1) {
            this.currentImg--
            this.preImg--
            this.matrixImageCenter = {
                'text-align': 'center',
            }
        }
        if (this.listImg[this.currentImg - 1]) {
            this.dateDisplay = this.listImg[this.currentImg - 1].dateString
            this.imgActive = this.listImg[this.currentImg - 1].id
        } else {
            this.dateDisplay = ''
            this.imgActive = ''
        }
        this.caculatorPadding($event.target)

        this.fillShowImage()
    }

    getStyleImage(img, style, index) {
        if (style) {

            const rotate = (style.rotate ? style.rotate : 0)
            const scaleX = (style.scaleX ? style.scaleX : 1)
            const scaleY = (style.scaleY ? style.scaleY : 1)
            const currentMatrix = this.listImg[index] ? this.listImg[index].matrix : [1, 0, 0, 1]
            let object: any = this.parseObjectTranform(img.style.transform)
            const matrix = this.caculatorMatrixPreviewImage(img, 90, 60, currentMatrix)
            if (matrix) {
                object.matrix = matrix
            }
            object.rotate = rotate + 'deg'
            object.scaleX = scaleX
            object.scaleY = scaleY
            this.updateStyle(object, img)
        }
    }

    caculatorMatrixPreviewImage(sizeImage, widthFrame, heightFrame, matrixImage = [1, 0, 0, 1]) {
        if (sizeImage.width === 0 && sizeImage.height === 0) {
            return null
        }
        const widthRatio = widthFrame / sizeImage.width
        const heightRatio = heightFrame / sizeImage.height
        const ratioMin = widthRatio < heightRatio ? widthRatio : heightRatio
        const n1 = ratioMin * matrixImage[0] // n1
        const n2 =
            (heightFrame / sizeImage.width) *
            matrixImage[1] // n2
        const n3 =
            (heightFrame / sizeImage.width) *
            matrixImage[2] // n3
        const n4 = ratioMin * matrixImage[3] // n4
        const n5 = (widthFrame - sizeImage.width) / 2
        const n6 = (heightFrame - sizeImage.height) / 2

        return n1 + ',' + n2 + ',' + n3 + ',' + n4 + ',' + n5 + ',' + n6
    }

    updateStyle(object, image) {
        let string = ''
        let string1 = ''
        for (const key in object) {
            if (key === 'matrix') {
                string += key + '(' + object[key] + ') '
            } else {
                string1 += key + '(' + object[key] + ') '
            }
        }
        image.style.transform = string + ' ' + string1
    }

    parseObjectTranform(stringTranform) {
        const regex = /(\w+)\((.+?)\)/g
        let transform = {}
        let matchS: any
        while ((matchS = regex.exec(stringTranform))) {
            transform[matchS[1]] = matchS[2]
        }
        return transform
    }

    caculatorDataImg() {
        let data = {
            id: '',
            dateString: '',
            matrix: [1, 0, 0, 1],
            style: {},
        }
        for (let i = 0; i < this.arrayTitleImage.length; i++) {
            for (let j = 0; j < this.arrayTitleImage[i].subTitle.length; j++) {
                this.arrayTitleImage[i].subTitle[j].data = []
            }
        }

        if (this.clientVisitInfo) {
            // console.log(this.clientVisitInfo);
            const arrSort = sortBy(this.clientVisitInfo, ['dateString'])
            // sortBy(users, ['user', 'age']);
            // console.log(arrSort);
            for (let i = 0; i < arrSort.length; i++) {
                let dateString = arrSort[i].dateString
                this.jsonInitClientVisit = arrSort[i]
                this.initJsonClientVisit(this.jsonInitClientVisit)
                arrSort[i] = this.jsonInitClientVisit
                for (let j = 0; j < this.arrayTitleImage.length; j++) {
                    for (let k = 0; k < this.arrayTitleImage[j].subTitle.length; k++) {
                        let arrayData = arrSort[i][this.arrayTitleImage[j].subTitle[k].key]
                        for (let h = 0; h < arrayData.length; h++) {
                            data = {
                                id: '',
                                dateString: dateString,
                                matrix: [1, 0, 0, 1],
                                style: {},
                            }
                            if (arrayData[h]) {
                                if (arrayData[h].id && arrayData[h].id != '') {
                                    data.id = arrayData[h].id
                                    if (arrayData[h].matrix) {
                                        data.matrix = arrayData[h].matrix
                                    }
                                    if (arrayData[h].style) {
                                        data.style = arrayData[h].style
                                    }
                                    this.arrayTitleImage[j].subTitle[k].data.push(data)
                                }
                            }
                        }
                    }
                }
            }
        }
        this.listImg = this.arrayTitleImage[1].subTitle[0].data
        this.getImageMatrix()
    }

    caculatorMatrix(img, parent_img) {

        this.matrixImageCenter = {
            'text-align': 'initial',
        }
        this.showImgMatrix = true
        // img.style.opacity = 1
    }

    getImageMatrix() {
        this.listMatrix = []
        for (let i = 0; i < this.listImg.length; i++) {
            this.listMatrix.push(this.listImg[i].matrix)
        }
    }

    checkImgSrc(img, digest) {
        //Todo: xu ly anh noimage
        // img.src = imageUrl + digest;
        img.src = getImageRedirectUrl(digest)
    }

    initJsonClientVisit(json: any = {}) {
        this.jsonInitClientVisit['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonInitClientVisit['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonInitClientVisit['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonInitClientVisit['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonInitClientVisit['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonInitClientVisit['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonInitClientVisit['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
    }

    private caculatorPadding(scrollTarget: any) {
        this.matrixImageCenter = {
            'text-align': 'initial',
        }
        this.paddingScroll = scrollTarget.offsetWidth / 2
    }
}



// WEBPACK FOOTER //
// ./src/app/client-app/image/image.component.ts